module.exports = __webpack_public_path__ + "media/images/responsive/flow/resort_online_step_02-5c17628318c371ee5f1fdda91b4a8793.jpg";